export class SoundDetection {
  constructor() {
    this.isAbnormalFeed = null
    this.audioContext = null
    this.analyser = null
    this.dataArray = null
    this.source = null
  }
  detectSound(audioStreem, onNoiseDetected, text) {
    // Create AudioContext

    this.stopDetection()

    this.isAbnormalFeed = false
    this.threshold = 0.18
    this.audioContext = new AudioContext()
    this.source = this.audioContext.createMediaStreamSource(audioStreem)
    this.analyser = this.audioContext.createAnalyser()
    this.analyser.fftSize = 256

    this.source.connect(this.analyser)

    const bufferLength = this.analyser.frequencyBinCount
    this.dataArray = new Uint8Array(bufferLength)

    const checkLevel = () => {
      this.analyser.getByteFrequencyData(this.dataArray)

      // Compute average volume
      let sum = 0
      for (let i = 0; i < bufferLength; i++) {
        sum += this.dataArray[i]
      }
      const avg = sum / bufferLength / 255 // normalized 0-1
      console.log(avg)
      // Trigger callback if above threshold
      if (avg > this.threshold && onNoiseDetected && !this.isAbnormalFeed) {
        this.isAbnormalFeed = true
        console.log(
          text,
          'text====================================================================='
        )

        onNoiseDetected(true)
      } else if (avg < this.threshold && this.isAbnormalFeed) {
        // onNoiseDetected(avg)
        console.log('no noise detected')
        this.isAbnormalFeed = false

        onNoiseDetected(false)
      }

      this.rafId = requestAnimationFrame(checkLevel)
    }

    checkLevel()

    // if (audioStreem > 0 && !this.isAbnormalFeed) {
    //   this.isAbnormalFeed = true
    //   audioStreem(true)
    // } else if (this.isAbnormalFeed) {
    //   this.isAbnormalFeed = true

    //   audioStreem(false)
    // }
  }

  // async stopDetection() {
  //   if (this.rafId) {
  //     cancelAnimationFrame(this.rafId)
  //     this.rafId = null
  //   }

  //   console.log(this.audioContext, 'closed |||||||||||||||||||||||||||||||||||||||||||||')

  //   if (this.audioContext && this.audioContext.state !== 'closed') {
  //     this.audioContext.close()
  //   }
  // }
  stopDetection() {
    console.log('Stopping sound detection')

    // Stop animation loop
    if (this.rafId) {
      cancelAnimationFrame(this.rafId)
      this.rafId = null
    }

    // Disconnect nodes
    if (this.source) {
      try {
        this.source.disconnect()
      } catch {}
      this.source = null
    }

    if (this.analyser) {
      try {
        this.analyser.disconnect()
      } catch {}
      this.analyser = null
    }

    // Close AudioContext safely
    if (this.audioContext) {
      const ctx = this.audioContext
      this.audioContext = null

      try {
        if (ctx.state !== 'closed') {
          ctx.close()
        }
      } catch {}
    }

    this.dataArray = null
    this.isAbnormalFeed = false
  }
}
